export default __webpack_public_path__ + "static/media/DK.734c76e7.jpeg";